import React from "react";
import { Box } from "@mui/material";
import { FN } from "./facilityNetworkTheme";

type Props = {
  children: React.ReactNode;
  padding?: number;
  gap?: number;
};

export default function FacilityNetworkFigmaCard({
  children,
  padding,
  gap,
}: Props) {
  return (
    <Box
      sx={{
        bgcolor: "#fff",
        border: `1px solid ${FN.figmaCardBorder}`,
        borderRadius: FN.figmaCardRadius,
        boxShadow: FN.figmaCardShadow,
        p: padding ?? 2,
        display: "flex",
        flexDirection: "column",
        gap: gap ?? 0.5,
        minWidth: 0,
        maxWidth: "100%",
        width: "100%",
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      {children}
    </Box>
  );
}
